import styled from 'styled-components';

import { colors } from '../../../styles/constants';

export const UKPhoneInputContainer = styled.div`
  display: flex;
  align-items: stretch;
  border-radius: 8px;
  border: 1px solid;
  overflow: hidden;
  height: 40px;
  position: relative;
  z-index: 1;
  /* Solid fill so hero / image underlays cannot show through on split layouts (e.g. /pro).
     Double ampersand repeats the class for higher specificity than global input/reset rules. */
  && {
    background-color: ${colors.white} !important;
  }

  ${({ theme }) => theme.mediaQuery.sm} {
    height: 56px;
  }
`;

export const UKPhoneInputPrefix = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding-left: 12px;
  padding-right: 8px;
  height: 100%;
  background-color: ${colors.lightGray};
  border-right: 1px solid ${colors.midGray};
  user-select: none;
  flex-shrink: 0;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: ${colors.ebonyClay};

  ${({ theme }) => theme.mediaQuery.sm} {
    padding-left: 18px;
    padding-right: 12px;
    font-size: 16px;
  }
`;

export const UKPhoneInputFlagIcon = styled.span`
  display: flex;
  align-items: center;
  line-height: 0;
`;

export const UKPhoneInputElement = styled.input`
  flex: 1;
  border: none;
  outline: none;
  height: 100%;
  font-family: 'Roboto', sans-serif;
  font-weight: 300;
  font-size: 16px;
  padding-inline: 12px;
  min-width: 0;
  box-shadow: none;
  color: ${colors.ebonyClay};
  cursor: text;
  pointer-events: auto;
  -webkit-appearance: none;
  appearance: none;

  && {
    background-color: ${colors.white} !important;
  }

  &::placeholder {
    color: ${colors.silverChalice};
  }

  ${({ theme }) => theme.mediaQuery.sm} {
    font-size: 18px;
    padding-inline: 18px;
  }
`;
